import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Divider } from 'veloe-ds';

import './styles.scss';

class ComponenteResumoDaCompra extends Component {
  render() {
    const { listaDeProdutos, ondeUsar } = this.props.pedido;
    let valorTotal = 0;

    listaDeProdutos.forEach((produto) => {
      valorTotal += produto.valor * produto.quantidade;
    });
    if (listaDeProdutos.length) {
      return (
        <div className="containerHeaderResumoCompra">
          <div className="containerTituloResumoCompra">
            <label className="lblTextoMuitoDestaque">Resumo da compra</label>
          </div>

          <div className="containerHeaderInfosResumoCompra">
            <Divider type="full" onBg="dark" />
            {listaDeProdutos.map((produto) => {
              return (
                <React.Fragment key={produto.id}>
                  <div className="containerInfosTextos">
                    <label className="lblTextoPoucoDestaque">
                      {produto.titulo}
                    </label>
                  </div>

                  <div className="containerInfosTextos">
                    <label className="lblTextoSemDestaque">Quantidade</label>
                    <label className="lblTextoSemDestaque">
                      {produto.quantidade}
                    </label>
                  </div>

                  <div className="containerInfosTextos">
                    <label className="lblTextoSemDestaque">Valor</label>
                    {produto.ehGratis.gratis ? (
                      <>
                        <div className="containerValorProdutoHeader">
                          <label
                            className="lblTextoSemDestaque"
                            style={{ textDecoration: 'line-through' }}
                          >
                            {(produto.valorOriginal * produto.quantidade)
                              .toFixed(2)
                              .replace('.', ',')}
                          </label>
                          <label className="lblTextoSemDestaque">
                            {produto.valor.toFixed(2).replace('.', ',')}
                          </label>
                        </div>
                      </>
                    ) : (
                      <label className="lblTextoSemDestaque">
                        {/* R$ {produto.valor.toFixed(2).replace(".", ",")} */}
                        Grátis
                      </label>
                    )}
                  </div>

                  <div className="containerInfosTextos">
                    <label className="lblTextoSemDestaque">Onde usar</label>
                    <label className="lblTextoSemDestaque">
                      {ondeUsar.texto}
                    </label>
                  </div>

                  <Divider type="full" onBg="dark" />
                </React.Fragment>
              );
            })}

            <div className="containerInfosTextos">
              <label className="lblTextoDestaque">Total</label>
              <label className="lblTextoDestaqueTotalValor">
                R$ {valorTotal.toFixed(2).replace('.', ',')}
              </label>
            </div>
            <Divider type="full" onBg="dark" />
          </div>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ app, pedido }) => {
  return { app, pedido };
};

export default connect(mapStateToProps)(ComponenteResumoDaCompra);
